repaymentCalculator = {
    calculatePayments: function (repaymentCalculatorHolder) {
        var loanAmount = parseInt(repaymentCalculatorHolder.find('.amount-range').val()) || 0,
            loanLength = parseInt(repaymentCalculatorHolder.find('.length-range').val()) || 0,
            paymentWeeks = Math.ceil(loanLength * weekFortnightMonths['weekly']),
            monthlyPayments = monthlyPaymentsCalculator(loanAmount, loanLength),
            weeklyPayments = monthlyPayments / weekFortnightMonths['weekly'];

        repaymentCalculatorHolder.find('.loan-length').text(
            loanLength.toString() + ' months'
        );

        repaymentCalculatorHolder.find('.loan-total').text(
            loanAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        );

        repaymentCalculatorHolder.find('.loan-repayments').text(
            paymentWeeks.toString() + ' weekly payments of $' + weeklyPayments.toFixed(2)
        );

        repaymentCalculatorHolder.find('.full-amount').text(
            currencyHelpers.toFormatted( (monthlyPayments * loanLength) )
        );
    }
};


jQuery(document).ready(function () {
    jQuery('.repayment-calculator input').on('change input', function () {
        repaymentCalculator.calculatePayments(jQuery(this).closest('.repayment-calculator'));
    });

    jQuery.each(jQuery('.repayment-calculator'), function (i, elem) {
        repaymentCalculator.calculatePayments(jQuery(elem));
    });
});



